import { z } from 'zod';
import { GENERATION_FOLLOW_UPS, GENERATION_GOALS, generationOptionsSchema, } from './generationGoals.js';
/**
 * A studio project: one request and everything made from it.
 *
 * The user types an idea once; the post text, the image/video/audio prompts,
 * the generated media, their revisions, and finally where it was published
 * all belong to that one record. The archive lists projects, not the separate
 * jobs they are made of.
 *
 * The jobs and video plans inside a project keep their existing DTOs; this
 * file holds only what is new at the project level.
 */
/** How a project's output reached publishing. */
export const GenerationPublicationMode = {
    /** A new post made in the composer from the project's text and media. */
    NEW_POST: 'NEW_POST',
    /** The project's media was added to a post that was already scheduled. */
    ATTACHED: 'ATTACHED',
};
/** Create an empty project from the request; jobs are added to it afterwards. */
export const createGenerationProjectSchema = z.object({
    requestText: z.string().trim().min(1).max(20_000),
    title: z.string().trim().min(1).max(200).optional(),
    referenceMediaIds: z.array(z.string().uuid()).max(20).default([]),
    /**
     * The end product wanted. When present the server writes the first text
     * step(s) itself (with `followUp`, a post's matching picture or video prompt
     * in parallel); when absent the project is an empty container as before.
     */
    goal: z.enum(GENERATION_GOALS).optional(),
    followUp: z.enum(GENERATION_FOLLOW_UPS).default('NONE'),
    options: generationOptionsSchema.optional(),
});
/** Record that a project's output went to publishing. Sent by the web app after the post is saved. */
export const recordGenerationPublicationSchema = z.object({
    publishJobId: z.string().uuid(),
    mode: z.enum(['NEW_POST', 'ATTACHED']),
    mediaIds: z.array(z.string().uuid()).max(20).default([]),
});
//# sourceMappingURL=generationProject.js.map